<fury-page-layout>
    <fury-page-layout-content @fadeInUp>
        <fury-container>
            <div fxFlex="100" fxLayout="column">
                <h1>Uw melding hebben wij in goede orde ontvangen</h1>
                <p>
                    Indien u heeft aangegeven om op de hoogte te blijven, ontvang u per e-mail een bevestiging van uw melding. Hierin vindt u ook
                    een link naar de website die u altijd inzicht geeft in de actuele status van uw melding. Ook ontvangt u automatisch een e-mail
                    notificatie als de status van uw melding veranderd.
                </p>
                <ng-container *ngIf="!webformService.report && !isLoading">
                    <fury-alert-box class="warn" style="margin: 30px auto;padding:15px 45px;">
                        Er is geen melding gevonden.
                    </fury-alert-box>
                </ng-container>
                <h2 *ngIf="!isLoading && webformService.report">Uw meldnummer: {{ webformService.report?.number }}</h2>
                <mat-progress-spinner *ngIf="isLoading" mode="indeterminate" diameter="32"></mat-progress-spinner>
                <div fxFlex fxLayout="column" fxLayoutGap="36px">
                    <a color="primary" mat-button href="{{ environment.appVersionAddon === '' ? 'https://www.milieuklachtencentrale.nl' : 'https://www.mka-staging.nl' }}">
                        Scherm sluiten, terug naar de homepage
                    </a>
                    <h3 *ngIf="webformService.report?.report_type_id === 1">Heeft u uw melding anoniem ingediend?</h3>
                    <p class="max-width">
                        Door het opslaan van onderstaande link heeft u inzicht in de actuele status van uw melding. Na het sluiten van deze pagina wordt deze
                        link niet meer weergegeven.
                    </p>
                    <a href="{{ webformService.report?.track_and_trace_url }}" target="_blank">
                        {{ webformService.report?.track_and_trace_url }}
                    </a>
                </div>
            </div>
        </fury-container>
    </fury-page-layout-content>
</fury-page-layout>
